import React, {useEffect, useState} from 'react';
import { Modal, Paper } from '@mui/material';
import AssignMissionAssetLayout from '../layouts/AssignMissionAssetLayout';
import getAssets from "../../../data/asset/getAssets";

function AssignMissionAssetModal(props: {
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function,
    onNetworkError: Function
}) {
    const [assetList, setAssetList] = useState(undefined)

    useEffect(() => {
        if (props.isOpen) {
            getAssets()
                .then((result) => setAssetList(result))
                .catch((err) => {
                    console.error(err)
                    props.onNetworkError()
                })
        }
    }, [props.isOpen])

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '400px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <AssignMissionAssetLayout
                    title="Assign Asset"
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                    assetList={assetList}
                />
            </Paper>
        </Modal>
    );
}

export default AssignMissionAssetModal;